import { Container, Sprite, Text } from 'pixi.js';
import { LOCALE_DATA } from '../constant';
import { Store, TextureFactory } from '../core';

class NotificationNinimo extends Container {
  public notificationText: Text;

  constructor() {
    super();
    const sprite = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/notification_nini.png'));
    sprite.scale.set(0.5);
    sprite.anchor.set(1, 0.75);
    this.addChild(sprite);

    this.notificationText = new Text(LOCALE_DATA[Store.instance.state.locale].COPY_LINK, {
      fontSize: 22,
      fontWeight: '900',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      fill: '0x4a282f',
      padding: 10,
      align: 'center',
    });
    this.notificationText.anchor.set(0.5);
    this.notificationText.x = -105;
    this.notificationText.y = -150;
    this.addChild(this.notificationText);
  }
}

export default NotificationNinimo;
